import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { BrowserModule } from '@angular/platform-browser'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { LoggerModule, NgxLoggerLevel } from 'ngx-logger'

import { MatButtonModule } from '@angular/material/button'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatDialogModule } from '@angular/material/dialog'
import { MatDividerModule } from '@angular/material/divider'
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input'
import { MatListModule } from '@angular/material/list'
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu'
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio'
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select'
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle'
import { MatCardModule } from '@angular/material/card'
import { AppComponent } from './app.component'
import { KcMessageComponent } from './components/kc-message/kc-message.component'

import { RevolutionRegisterFinishComponent } from './views/revolution/revolution-register-finish/revolution-register-finish.component'

import { KcTranslatePipe } from './kc-translate.pipe'
import { SafePipe } from './safe.pipe'
import { UnescapePipe } from './unescape.pipe'

import {
  CPTMissingTranslationHandler,
  IconModule,
  CustomerPortalSharedModule,
  NotTranslatedService
} from '@inside-hub-app/customer-portal-shared'
import {
  type B2CConfig,
  CustomerPortalCustomerPortalConfigModule
} from '@inside-hub-app/customer-portal-config'
import { EfRemoteConfigModule } from '@inside-hub-app/ef-remote-config'
import { LayoutModule } from '@angular/cdk/layout'
import { HttpClientModule } from '@angular/common/http'
import { MatDatepickerModule } from '@angular/material/datepicker'
import {
  MissingTranslationHandler,
  TranslateModule
} from '@ngx-translate/core'

import {
  PpModule,
  type PpModuleConfig
} from '@inside-hub-app/ef-ng-pp-client'
import { KcCustomCalendarHeaderComponent } from './components/kc-custom-calendar-header/kc-custom-calendar-header.component'
import { KcLocalizationMenuComponent } from './components/kc-localization-menu/kc-localization-menu.component'
import { RevolutionChooseExistingComponent } from './views/revolution/revolution-choose-existing/revolution-choose-existing.component'
import { KcCompanyDetailsComponent } from './views/kc-company-details/kc-company-details.component'
import { KcCompanyRequestChangeComponent } from './views/kc-company-request-change/kc-company-request-change.component'
import { RevolutionTelephoneValidationComponent } from './views/revolution/revolution-telephone-validation/revolution-telephone-validation.component'

import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner'
import { GoogleTagManagerModule } from 'angular-google-tag-manager'
import {
  B2CModule,
  type Environment as B2cEnvironment
} from '@inside-hub-app/customer-portal-b2c-client'
import { DontHaveAccountComponent } from './components/revolution/dont-have-account/dont-have-account.component'
import { KcRegisterBusinessInviteFinishComponent } from './views/kc-register-business-invite-finish/kc-register-business-invite-finish.component'
import { RevolutionActivationFinishComponent } from './views/revolution/revolution-activation-finish/revolution-activation-finish.component'
import { RevolutionErrorComponent } from './views/revolution/revolution-error/revolution-error.component'
import { RevolutionInfoComponent } from './views/revolution/revolution-info/revolution-info.component'
import { RevolutionLoginComponent } from './views/revolution/revolution-login/revolution-login.component'
import { RevolutionMainViewComponent } from './views/revolution/revolution-main-view/revolution-main-view.component'
import { RevolutionPersonalizeNewComponent } from './views/revolution/revolution-personalize-new/revolution-personalize-new.component'
import { RevolutionRegisterBusinessInviteComponent } from './views/revolution/revolution-register-business-invite/revolution-register-business-invite.component'
import { RevolutionRegisterComponent } from './views/revolution/revolution-register/revolution-register.component'
import { RevolutionRequestBusinessInviteComponent } from './views/revolution/revolution-request-business-invite/revolution-request-business-invite.component'
import { RevolutionResetPasswordComponent } from './views/revolution/revolution-reset-password/revolution-reset-password.component'
import { RevolutionSetPasswordComponent } from './views/revolution/revolution-set-password/revolution-set-password.component'
import { RevolutionUpdatePasswordComponent } from './views/revolution/revolution-update-password/revolution-update-password.component'
import { RevolutionKcConsentsComponent } from './views/revolution/revolution-consents/revolution-consents.component'
import { RevolutionEnterTelephoneComponent } from './views/revolution/revolution-enter-telephone/revolution-enter-telephone.component'
import { KcRequestBusinessSentComponent } from './views/kc-request-business-sent/kc-request-business-sent.component'
import { RevolutionLoginWebwidgetComponent } from './views/revolution/revolution-login-webwidget/revolution-login-webwidget.component'
import { RevolutionKcGdprComponent } from './views/revolution/revolution-gdpr/revolution-gdpr.component'
import { TxNativeModule } from '@emilfreydigital/transifex-angular'
import { RevolutionVinValidationComponent } from './views/revolution/revolution-vin-validation/revolution-vin-validation.component'
import { RevolutionEmailChangeComponent } from './views/revolution/revolution-email-change/revolution-email-change.component'
import { RevolutionSamlPostComponent } from './views/revolution/revolution-saml-post/revolution-saml-post.component'

const remoteConfig = (window as any).ef.remoteConfig.configuration as B2CConfig

const ppEnvironments: PpModuleConfig = {
  storagePrefix: remoteConfig['ppEnvironments.kc.storagePrefix'],
  translationPrefix: remoteConfig['ppEnvironments.kc.translationPrefix'],
  environment: {
    domain: remoteConfig['ppEnvironments.kc.environment.domain'],
    baseUrl: remoteConfig['ppEnvironments.kc.environment.baseUrl'],
    authorizationExcludedUrls: [
      {
        pattern:
          remoteConfig[
            'ppEnvironments.kc.environment.authorizationExcludedUrls.0.pattern'
          ]
      },
      {
        pattern:
          remoteConfig[
            'ppEnvironments.kc.environment.authorizationExcludedUrls.1.pattern'
          ]
      },
      {
        pattern:
          remoteConfig[
            'ppEnvironments.kc.environment.authorizationExcludedUrls.2.pattern'
          ]
      }
    ]
  }
}
@NgModule({
  declarations: [
    AppComponent,
    RevolutionRegisterFinishComponent,
    KcMessageComponent,
    KcTranslatePipe,
    SafePipe,
    UnescapePipe,
    KcLocalizationMenuComponent,
    RevolutionChooseExistingComponent,
    RevolutionTelephoneValidationComponent,
    RevolutionEnterTelephoneComponent,
    RevolutionPersonalizeNewComponent,
    KcCustomCalendarHeaderComponent,
    KcCompanyDetailsComponent,
    KcCompanyRequestChangeComponent,
    KcRegisterBusinessInviteFinishComponent,
    RevolutionLoginWebwidgetComponent,
    RevolutionMainViewComponent,
    RevolutionLoginComponent,
    RevolutionResetPasswordComponent,
    DontHaveAccountComponent,
    RevolutionUpdatePasswordComponent,
    RevolutionRequestBusinessInviteComponent,
    KcRequestBusinessSentComponent,
    RevolutionActivationFinishComponent,
    RevolutionErrorComponent,
    RevolutionInfoComponent,
    RevolutionRegisterBusinessInviteComponent,
    RevolutionSetPasswordComponent,
    RevolutionRegisterComponent,
    RevolutionKcConsentsComponent,
    RevolutionVinValidationComponent,
    RevolutionKcGdprComponent,
    RevolutionEmailChangeComponent,
    RevolutionSamlPostComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    LayoutModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatDialogModule,
    MatRadioModule,
    MatSelectModule,
    MatIconModule,
    MatDividerModule,
    MatSlideToggleModule,
    MatProgressSpinnerModule,
    MatInputModule,
    MatButtonModule,
    MatMenuModule,
    MatListModule,
    MatCardModule,
    MatDatepickerModule,
    CustomerPortalSharedModule,
    LoggerModule.forRoot({
      enableSourceMaps: !remoteConfig.production,
      level: !remoteConfig.production
        ? NgxLoggerLevel.DEBUG
        : NgxLoggerLevel.ERROR
    }),
    TranslateModule.forRoot({
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: CPTMissingTranslationHandler,
        deps: [NotTranslatedService]
      }
    }),
    // pp client
    PpModule.forRoot(ppEnvironments),
    TxNativeModule.forRoot(),
    // Google tag manager
    GoogleTagManagerModule.forRoot({
      id: remoteConfig['googleTagManager.gtmId']
    }),
    B2CModule.forRoot({
      environment: remoteConfig['b2c.environment'] as B2cEnvironment,
      apiKey: remoteConfig['b2c.apiKey'],
      // cordovaLoginRedirectUri: 'https://dev-cpt-de.emilfreydigital.hr'
      cordovaLoginRedirectUri:
        'android-app://hr.emilfreydigital.customerportal/https/dev-cpt-de.emilfreydigital.hr/'
    }),
    IconModule.forRoot({
      iconsPath: './assets/icons',
      useKcResourcePath: true
    }),
    EfRemoteConfigModule,
    CustomerPortalCustomerPortalConfigModule
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
